import Angular from "angular";
import Controller from "./chart-workload-colors.controller";
import Template from "./chart-workload-colors.html";

export default Angular.module('chart-workload-colors', [])
    .component('chartWorkloadColors', {
        template: Template,
        controller: Controller,
        bindings: {
            workloads: '<'
        },
    })



// WEBPACK FOOTER //
// ./src/modules/main/components/chart-workload-colors/chart-workload-colors.js